// App.js
import React, { useState } from 'react';
import StartCard from './0StartCard';
import ChooseTraining from './0ChooseTraining';
import PreLevel1 from './1PreLevel1';  // Add this import
import Level1 from './1Level1';
import WinScreen from './9WinScreen';
import LoseScreen from './9LoseScreen';
import LearnMore from './9LearnMore';
import ClaimMyAccount from './9ClaimMyAccount';

const App = () => {
  const [gameState, setGameState] = useState('intro');
  const [selectedTraining, setSelectedTraining] = useState(null);

  const handleStartGame = () => {
    setGameState('chooseTraining');
  };

  const handleTrainingSelect = (trainingType) => {
    setSelectedTraining(trainingType);
    setGameState('preLevel1');  // Changed from 'level1' to 'preLevel1'
  };

  const handlePreLevelComplete = () => {
    setGameState('level1');
  };

  const handleWin = () => {
    setGameState('won');
  };

  const handleLose = () => {
    setGameState('lost');
  };

  const handleLearnMore = () => {
    setGameState('learnMore');
  };

  const handleClaimAccount = () => {
    setGameState('claimAccount');
  };

  const handlePlayDifferentLevel = () => {
    setGameState('chooseTraining');
  };

  const handleClaimComplete = () => {
    setGameState('chooseTraining');
  };

  switch (gameState) {
    case 'intro':
      return <StartCard onStart={handleStartGame} />;

    case 'chooseTraining':
      return <ChooseTraining onSelect={handleTrainingSelect} />;

    case 'preLevel1':  // Add this case
      return (
        <PreLevel1 
          onStart={handlePreLevelComplete}
          trainingType={selectedTraining}
        />
      );

    case 'level1':
      return (
        <Level1 
          onWin={handleWin} 
          onLose={handleLose}
          trainingType={selectedTraining} 
        />
      );

    case 'won':
      return (
        <WinScreen 
          onLearnMore={handleLearnMore}
          onPlayDifferentLevel={handlePlayDifferentLevel}
        />
      );

    case 'learnMore':
      return <LearnMore onClaimAccount={handleClaimAccount} />;

    case 'claimAccount':
      return <ClaimMyAccount onFinish={handleClaimComplete} />;

    case 'lost':
      return <LoseScreen onRetry={() => setGameState('level1')} />;

    default:
      return <StartCard onStart={handleStartGame} />;
  }
};

export default App;